import type { Hook } from '../types';
import { getLayer } from '../../layer';

const CACHE_KEY = 'layoutInfo';

function buildLayoutInfo(...args: Parameters<Hook['layout']>) {
  const [{ spec, util: utils }] = args;

  let hasNormalLayer = false;
  let hasStandardChartLayer = false;
  let hasHXKLineLayer = false;
  let hasIndependentLayer = false;
  let hasExternalLayer = false;

  spec?.view?.main?.layers?.forEach(layer => {
    const layerDefine = getLayer(layer.type);

    if (layerDefine.isNormalLayer) {
      hasNormalLayer = true;
    }
    if (layerDefine.isStandardChartLayer) {
      hasStandardChartLayer = true;
    }
    if (layerDefine.isHXKLineLayer) {
      hasHXKLineLayer = true;
    }
    if (layerDefine.isExternalLayer) {
      hasExternalLayer = true;
    }
    if (layerDefine.isIndependentLayer) {
      hasIndependentLayer = true;
    }
  });

  const hasSimpleKLine = (spec?.view?.secondary?.layers?.length || 0) > 0;

  return {
    mainView: {
      hasNormalLayer,
      hasStandardChartLayer,
      hasHXKLineLayer,
      hasIndependentLayer,
      hasExternalLayer
    },
    secondaryView: {
      enable: typeof spec?.view?.secondary !== 'undefined' && hasSimpleKLine,
      hasSimpleKLine
    },
    isShowDataZoom: (inputLayout: string, barNum: number) => {
      let dataZoomLimit: number = barNum;
      let showDataZoom: boolean = true;
      // 设计规定的不同卡片大小下开启dataZoom的柱子数量
      const lengthLimit1 = 18;
      const lengthLimit2 = 40;
      const lengthLimit3 = 60;

      if (
        (inputLayout === utils.const.LAYOUT.SMALL ||
          inputLayout === utils.const.LAYOUT.SMALL_1_2) &&
        barNum > lengthLimit1
      ) {
        dataZoomLimit = lengthLimit1;
      } else if (
        (inputLayout === utils.const.LAYOUT.SMALL_2_1 ||
          inputLayout === utils.const.LAYOUT.LARGE) &&
        barNum > lengthLimit2
      ) {
        dataZoomLimit = lengthLimit2;
      } else if (inputLayout === utils.const.LAYOUT.LARGE_3_2 && barNum > lengthLimit3) {
        dataZoomLimit = lengthLimit3;
      } else {
        showDataZoom = false;
      }
      return {
        showDataZoom,
        dataZoomLimit
      };
    }
  } as ReturnType<Hook['layout']>;
}

export function layout(...args: Parameters<Hook['layout']>) {
  const [api] = args;
  const layoutResult = api.cache.get(CACHE_KEY) || buildLayoutInfo(...args);

  api.cache.set(CACHE_KEY, layoutResult);

  return layoutResult;
}
